<style >
.v-list__tile__action {
  min-width:40px !important;
}
</style>
<template>
<v-list-tile
  @click.native='$emit("listitem:clicked", appointment)'
  :key="appointment.id"
  :disabled="disabled"
  :class='listItemColor' >

  <slot name='actions' >
    <v-list-tile-action v-if=withActions >
      <appointment-action-menu :appointment='appointment' >
      </appointment-action-menu >
    </v-list-tile-action>
  </slot>
  <v-list-tile-content class='appointment-list-item-content' >
    <slot name='title' >
      <v-list-tile-title v-if='appointment' >
        <!-- {{dateformat(appointment.start_time, 'H:mm')}}: -->
        <v-tooltip v-if='appointment.is_online' bottom >
          <template v-slot:activator="{ on }">
          <v-icon v-on='on' small x-small >
            headset_mic
          </v-icon>
          </template>
          <span>This appointment is online</span>
        </v-tooltip>
        <v-chip label dark
          v-if='withStatusChips'
          :class='formattedStatus.theme' class='v-chip--x-small' >
          {{ formattedStatus.title }}
        </v-chip>
        <span v-if='appointment.title' v-text='appointment.title' />
        <span v-else v-text='appointment.full_name' />
        <v-btn
          v-if='appointment.zoom_meeting_id'
          :href='`https://zoom.us/meeting/${appointment.zoom_meeting_id}`'
          target='_blank'
          small x-small
          class='pa-0 ma-0'
          style='float:right'
          color='primary' flat text >Open in Zoom
          <v-icon class='ml-2' small>open_in_new</v-icon>
        </v-btn>
        <v-tooltip bottom :max-width='150'>
          <template v-slot:activator="{ on }">
            <v-chip
              v-on='on'
              @click='$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "InvoiceDetails", appointment])'
              v-if='appointment.invoiceable' class='v-chip--x-small'
              color='success' outline outlined label dark >Invoiceable</v-chip>
          </template>
          <span>Invoiceable is an optional manual flag that you can apply to keep
            track of which appointments can safely be invoiced
          </span>
        </v-tooltip>
        <strong v-if='$vuetify.breakpoint.xs' >{{ formatCurrency(appointment.currency, appointment.price) }}</strong>
      </v-list-tile-title>
    </slot>
    <slot name='sub-title' >
    <v-list-tile-sub-title >
      <!--<div v-if='appointment.product' >
        {{ getProductById(appointment.product).title }}
      </div>-->
      <div>
        {{ formatFromTo(appointment.start_time, appointment.end_time) }}
      </div>
    </v-list-tile-sub-title>
    <v-list-tile-sub-title v-if='withTags && appointment.tags' >
      <v-icon small>tag</v-icon> {{appointment.tags}}
    </v-list-tile-sub-title>
    <v-list-tile-sub-title >
      <template v-if='appointment.product_name' >
      {{appointment.product_name}}
      </template>
      <template v-if='appointment.practitioner_name' >
      with {{appointment.practitioner_name}}
      </template>
      <template v-if='appointment.address_name' >@ {{appointment.address_name}}</template>
    </v-list-tile-sub-title>
    </slot>
  </v-list-tile-content>
  <v-list-tile-action v-if='withPricing' class='hidden-xs-only' >
    <strong class='subheading' >{{ formatCurrency(appointment.currency, appointment.price) }}</strong>
  </v-list-tile-action>
  <slot name='action' >
  <v-list-tile-action v-if='withAction' >
    <v-btn icon @click="$emit('goto', appointment)" >
      <v-icon class="grey--text text--lighten-1">chevron_right</v-icon>
    </v-btn>
  </v-list-tile-action>
  </slot>
</v-list-tile>
</template>
<script type="text/javascript">
import AppointmentActionMenu from '@/components/appointment/actions/ActionMenu'

export default {
  name: 'AppointmentListItem',
  components: {AppointmentActionMenu},
  props: {
    appointment: { type: Object, required: true },
    withActions: { type: Boolean, default: false },
    withAction: { type: Boolean, default: true },
    withPricing: { type: Boolean, default: false },
    withTags: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    withColorCoding: { type: Boolean, default: true },
    withStatusChips: { type: Boolean, default: false }
  },
  computed: {
    listItemColor () {
      if (!this.withColorCoding) { return '' }
      return this.appointmentStatusClass
    },
    formattedStatus () {
      if (this.appointment && this.appointment.status) {
        return this.formatStatus(this.appointment.status)
      }
      return {}
    },
    appointmentStatusClass () {
      if (this.appointment.status) {
        return 'status-' + this.appointment.status.toLowerCase()
      }
    },
    threeLine () {
      return this.withTags
    }
  }
}
</script>
<style scoped>
.appointment-list-item-content .chip {
  margin: 0px;
  padding: 4px;
  font-size: 11px;
  color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// AppointmentListItem.vue?528efbaf